import React from "react";
import { List, Typography, Box, Divider } from "@material-ui/core";
import ExerciseItem from "./ExerciseItem";
import exerciseConstants from "constants/Exercises/exerciseConstants";

/**
 * Componente responsável por renderizar uma lista de exercícios.
 * Gerencia a exibição de estados vazios e a iteração sobre o array de dados.
 * * @author Willian
 * @param {Object} props Propriedades do componente.
 * @param {Array} props.exercises Lista de objetos de exercício a serem exibidos.
 * @param {string} props.language Idioma atual da interface ('pt' ou 'en').
 * @param {Function} props.onSelect Função chamada ao selecionar um item da lista.
 * @param {Function} [props.renderActions] Função opcional para renderizar ações customizadas para cada item.
 * @returns {JSX.Element} A lista de exercícios estruturada ou uma mensagem de lista vazia.
 */
export default function ExerciseList({
  exercises,
  language,
  onSelect,
  renderActions,
}) {
  const listLabels = exerciseConstants.list;

  /**
   * Verifica se a lista de exercícios é nula ou está vazia para exibir o estado amigável.
   */
  if (!exercises) {
    return (
      <Box p={4} textAlign="center">
        <Typography color="textSecondary">
          {listLabels.empty[language]}
        </Typography>
      </Box>
    );
  }

  if (exercises.length === 0) {
    return (
      <Box p={4} textAlign="center">
        <Typography color="textSecondary">
          {listLabels.empty[language]}
        </Typography>
      </Box>
    );
  }

  return (
    <List style={{ padding: 0 }}>
      {exercises.map((ex, index) => {
        // Determina se as ações devem ser renderizadas para este item específico
        let itemActions = null;
        if (renderActions) {
          itemActions = renderActions(ex);
        }

        let itemKey = index;
        if (ex.id) {
          itemKey = ex.id;
        }

        /**
         * Renderiza o item e o divisor condicionalmente sem operadores ternários.
         */
        return (
          <React.Fragment key={itemKey}>
            <ExerciseItem
              ex={ex}
              language={language}
              onClick={onSelect}
              actions={itemActions}
            />
            {/* Adiciona o divisor apenas se não for o último elemento da lista */}
            {index < exercises.length - 1 && <Divider component="li" />}
          </React.Fragment>
        );
      })}
    </List>
  );
}
